module.exports = __webpack_public_path__ + "static/media/listing-page-koh-samui.a9af9b9d.webp";